import firebase from "firebase";
const firebaseConfig = {
    apiKey: "AIzaSyAOt8TuDjHTQ62upVAaEXW09SwoE9MopYw",
    authDomain: "asdeveloper-s.firebaseapp.com",
    databaseURL: "https://asdeveloper-s.firebaseio.com",
    projectId: "asdeveloper-s",
    storageBucket: "asdeveloper-s.appspot.com",
    messagingSenderId: "808041690033",
    appId: "1:808041690033:web:5a6af7a6bae44fed7dc390",
    measurementId: "G-F6X1XNT71S"
};
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
export default db;